import React, { useState } from "react"
import Editor from "react-simple-code-editor"
import { Box, GlobalStyles, useTheme } from "@mui/material"
import { Prism } from "shared/lib/prism"

const defaultHighlight = (code) =>
  Prism.highlight(code ?? "", Prism.languages.html, "markup")

export const CodeEditor = ({ sx, highlight = defaultHighlight, ...props }) => {
  const theme = useTheme()
  const [focused, setFocused] = useState(false)

  return (
    <>
      <GlobalStyles
        styles={{ ".code-editor-textarea:focus": { outline: "none" } }}
      />
      <Box
        data-testid="code-editor"
        sx={{
          border: "1px solid",
          borderRadius: "8px",
          borderColor: focused ? theme.palette.primary.main : "#bdbdbd",
          outline: focused ? `1px solid ${theme.palette.primary.main}` : "none",
          overflow: "auto",
          "&:hover": {
            borderColor: focused ? "primary.main" : "black"
          },
          ...sx
        }}
        className={focused ? "focused" : ""}
      >
        <Editor
          {...props}
          highlight={highlight}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          textareaClassName="code-editor-textarea"
        />
      </Box>
    </>
  )
}
